import { Typography } from "@atoms";
import EditIcon from "@assets/icons/edit.svg";
import { StoryOptions } from "../storyFace.styles";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { StoryFormProvider } from "contexts/StoryFormContext";
import { useStoryDataContext } from "contexts/StoryContext";
import { AddPeople } from "@organisms";

function StoryCreatorActions() {
  const { t } = useTranslation();
  const [openEdit, setOpenEdit] = useState(false);
  const {story} = useStoryDataContext();

  if (!story) return <></>;

  return (
    <StoryOptions className="options">
      <div className="options-div">
        <Typography
          style={{ color: "#391D0A" }}
          onClick={() => setOpenEdit(!openEdit)}
        >
          <img
            src={EditIcon}
            alt="edit"
            style={{ marginRight: "6px" }}
          />
          {t("edit")}
        </Typography>
        {openEdit && (
          <StoryFormProvider initialStory={story}>
            <AddPeople isEdit open={openEdit} setOpen={setOpenEdit} />
          </StoryFormProvider>
        )}

      </div>
    </StoryOptions>
  );
}

export default StoryCreatorActions;
